import React from "react";

import { AuthContext, AuthContextType } from "./AuthContext";

export const useAuth = (): AuthContextType => {
  return React.useContext(AuthContext);
};
